var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico_sync"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7619_29282",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.18335,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7619_29282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sync",
    d: "M12.8503 15.875C12.6137 15.9723 12.4087 15.955 12.2353 15.823C12.062 15.691 11.9753 15.493 11.9753 15.229C11.9753 15.1043 12.017 14.9793 12.1003 14.854C12.1837 14.7293 12.2807 14.639 12.3913 14.583C13.2807 14.153 13.9857 13.5213 14.5063 12.688C15.027 11.8547 15.2873 10.938 15.2873 9.938C15.2873 9.29867 15.1693 8.68034 14.9333 8.083C14.6973 7.48634 14.3223 6.931 13.8083 6.417L13.3503 5.958V7.5C13.3503 7.68067 13.2807 7.837 13.1413 7.969C13.0027 8.101 12.85 8.167 12.6833 8.167C12.5027 8.167 12.3463 8.101 12.2143 7.969C12.0823 7.837 12.0163 7.68067 12.0163 7.5V4.396C12.0163 4.18734 12.0927 4.00334 12.2453 3.844C12.3987 3.684 12.5863 3.604 12.8083 3.604H15.9123C16.093 3.604 16.2493 3.67 16.3813 3.802C16.5133 3.934 16.5793 4.09034 16.5793 4.271C16.5793 4.45167 16.5133 4.608 16.3813 4.74C16.2493 4.872 16.093 4.938 15.9123 4.938H14.1833L14.6213 5.375C15.288 5.97234 15.788 6.67367 16.1213 7.479C16.4547 8.285 16.6213 9.10467 16.6213 9.938C16.6213 11.2433 16.2773 12.4273 15.5893 13.49C14.902 14.552 13.989 15.347 12.8503 15.875ZM4.45434 16.396C4.27367 16.396 4.11734 16.33 3.98534 16.198C3.85334 16.066 3.78734 15.9097 3.78734 15.729C3.78734 15.5483 3.85334 15.392 3.98534 15.26C4.11734 15.128 4.27367 15.062 4.45434 15.062H6.16234L5.72534 14.625C5.07201 14.0417 4.57534 13.3437 4.23534 12.531C3.89534 11.7183 3.72534 10.8953 3.72534 10.062C3.72534 8.75667 4.06901 7.57267 4.75634 6.51C5.44368 5.448 6.35667 4.653 7.49534 4.125C7.73201 4.02767 7.93701 4.045 8.11034 4.177C8.28434 4.309 8.37134 4.507 8.37134 4.771C8.37134 4.89567 8.32934 5.02067 8.24534 5.146C8.16268 5.27067 8.06568 5.361 7.95434 5.417C7.06568 5.847 6.36068 6.47867 5.83934 7.312C5.31868 8.14534 5.05834 9.062 5.05834 10.062C5.05834 10.7013 5.18001 11.323 5.42334 11.927C5.66601 12.531 6.04434 13.09 6.55834 13.604L6.99534 14.042V12.521C6.99534 12.3403 7.06501 12.184 7.20434 12.052C7.34301 11.92 7.49568 11.854 7.66234 11.854C7.84301 11.854 7.99934 11.92 8.13134 12.052C8.26334 12.184 8.32934 12.3403 8.32934 12.521V15.604C8.32934 15.8127 8.25301 15.9967 8.10034 16.156C7.94768 16.316 7.76001 16.396 7.53734 16.396H4.45434Z",
    fill: "#587E85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSmall);
export default __webpack_public_path__ + "static/media/loading_small.af82a1760a11ebbe5313a2fe6dfff908.svg";
export { ForwardRef as ReactComponent };